module.exports = __webpack_public_path__ + "img/10.b1fd0c05.jpg";